// extracted by mini-css-extract-plugin
export var counter = "Progress-module--counter--30oRM";
export var counter__progress = "Progress-module--counter__progress--18Iuh";
export var counter__progress__value = "Progress-module--counter__progress__value--2vf_X";